import { useToast } from "vue-toastification";

export function copyToClipboard(itemName = "", value = null) {
  const toast = useToast();
  navigator.clipboard.writeText(value).then(() => {
    toast.info(itemName + " copied: " + value);
  });
}
